import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import cookie from "react-cookies";
import { deliveryId } from "../Settings/Config";
class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      globalSettings: "",
      enableRewards: false,
      enableAscentisCRM: false,
      enablePromotions: false,
      enableAddress: false,
    };
  }

  componentWillReceiveProps(PropsDt) {
    if (this.state.globalSettings !== PropsDt.globalSettings) {
      console.log(PropsDt.globalSettings, "PropsDt.globalSettings");
      const settings = PropsDt.globalSettings;
      const companyEnableAscentisCRM =
        settings?.companyEnableAscentisCRM ?? false;
      const companyEnablePromocode = settings?.companyEnablePromocode ?? false;
      const companyEnableLoyalty = settings?.companyEnableLoyalty ?? false;
      const companyAvailability = settings?.companyAvailability ?? "";
      const companyAvailability_ =
        companyAvailability !== "" && companyAvailability !== null
          ? companyAvailability.split(",")
          : [];

      this.setState({
        globalSettings: PropsDt.globalSettings,
        enableAscentisCRM: companyEnableAscentisCRM,
        enableRewards: companyEnableLoyalty,
        enablePromotions: companyEnablePromocode,
        enableAddress:
          companyAvailability_.indexOf(deliveryId) >= 0 ? true : false,
      });
    }
  }

  logout(e) {
    e.preventDefault();
    cookie.remove("availability", { path: "/" });
    cookie.remove("availabilityName", { path: "/" });
    cookie.remove("deliveryDate", { path: "/" });
    cookie.remove("deliveryOption", { path: "/" });
    cookie.remove("isAdvanced", { path: "/" });
    cookie.remove("IsVerifiedUser", { path: "/" });
    cookie.remove("orderDateTime", { path: "/" });
    cookie.remove("orderHandledOutlet", { path: "/" });
    cookie.remove("orderSlotEndTime", { path: "/" });
    cookie.remove("orderSlotStrTime", { path: "/" });
    cookie.remove("orderSlotTxt", { path: "/" });
    cookie.remove("orderSlotVal", { path: "/" });
    cookie.remove("orderTat", { path: "/" });
    cookie.remove("outletName", { path: "/" });
    cookie.remove("pickupOption", { path: "/" });
    cookie.remove("redeemPoint", { path: "/" });
    cookie.remove("redeemPointAmount", { path: "/" });
    cookie.remove("slotType", { path: "/" });

    cookie.remove("redeemPoint", { path: "/" });
    cookie.remove("redeemPointAmount", { path: "/" });
    cookie.remove("discountApplied", { path: "/" });
    cookie.remove("promoFreeDelivery", { path: "/" });
    cookie.remove("discount", { path: "/" });
    cookie.remove("promoCode", { path: "/" });

    localStorage.removeItem("customerID");
    localStorage.removeItem("deliveryAddress");
    localStorage.removeItem("deliveryPostalCode");
    localStorage.removeItem("deliveryUnitNumber");
    localStorage.removeItem("deliveryFloorNumber");
    localStorage.removeItem("paymentRequestIdRapyd");
    localStorage.removeItem("zoneID");
    localStorage.removeItem("zoneName");
    localStorage.removeItem("token");
    
    this.props.history.push("/");
  }

  render() {
    return (
      <div className="dashboard-sidebar">
        <ul>
          <li className={this.props.active === "myprofile" ? "active" : ""}>
            <Link to={"/myprofile"}>My Profile</Link>
          </li>
          <li className={this.props.active === "myorders" ? "active" : ""}>
            <Link to={"/myorders"}>Orders</Link>
          </li>
          {this.state.enableAscentisCRM === true ||
            (this.state.enableRewards === true && (
              <li className={this.props.active === "rewards" ? "active" : ""}>
                <Link to={"/rewards"}>My Rewards</Link>
              </li>
            ))}
          {this.state.enablePromotions === true && (
            <li className={this.props.active === "mypromotion" ? "active" : ""}>
              <Link to={"/mypromotion"}>My Promotion</Link>
            </li>
          )}
          {this.state.enableAddress === true && (
            <li className={this.props.active === "myaddress" ? "active" : ""}>
              <Link to={"/myaddress"}>Address Book</Link>
            </li>
          )}
          {/* <li>
            <Link to={"/myprofile"}>Change Password</Link>
          </li> */}
          <li>
            <a href={"/"} onClick={this.logout.bind(this)}>
              Logout
            </a>
          </li>
        </ul>
      </div>
    );
  }
}
const mapStateTopProps = (state) => {
  var globalSettings = "";
  if (Object.keys(state.settings).length > 0) {
    if (state.settings[0].status === "ok") {
      globalSettings = state.settings[0].result;
    }
  }
  return {
    globalSettings: globalSettings,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};
export default connect(
  mapStateTopProps,
  mapDispatchToProps
)(withRouter(Sidebar));
